// extracted by mini-css-extract-plugin
module.exports = {"miPerfil":"RegisteredUserProfile_miPerfil__2EcVe","commentsAndSuscription":"RegisteredUserProfile_commentsAndSuscription__1gHqx"};